// 입력 마스크 — 숫자만 입력해도 형식에 맞게 - 를 자동 삽입한다.
// 모바일 공개 입력폼과 CRM 신청서 모달이 같은 함수를 써서 형식이 갈리지 않게 한다.

/** 주민번호: 숫자만 13자리까지, 6자리 뒤에 자동으로 - 삽입 */
export function formatRrn(raw: string): string {
  const d = raw.replace(/\D/g, "").slice(0, 13);
  if (d.length <= 6) return d;
  return `${d.slice(0, 6)}-${d.slice(6)}`;
}

/** 한국 휴대/유선전화: 02 는 2-3(4)-4, 그 외는 3-3(4)-4 자동 분할 */
export function formatPhone(raw: string): string {
  const d = raw.replace(/\D/g, "").slice(0, 11);
  if (d.startsWith("02")) {
    if (d.length <= 2) return d;
    if (d.length <= 5) return `${d.slice(0, 2)}-${d.slice(2)}`;
    if (d.length <= 9) return `${d.slice(0, 2)}-${d.slice(2, 5)}-${d.slice(5)}`;
    return `${d.slice(0, 2)}-${d.slice(2, 6)}-${d.slice(6)}`;
  }
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}-${d.slice(3)}`;
  if (d.length <= 10) return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
  return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7)}`;
}

/** 카드번호: 숫자만 최대 16자리, 4자리마다 공백 삽입 (1111 1111 1111 1111).
 *  국내 신용/체크카드는 사실상 모두 16자리라 16으로 고정한다. */
export function formatCard(raw: string): string {
  const d = raw.replace(/\D/g, "").slice(0, 16);
  return d.match(/.{1,4}/g)?.join(" ") ?? "";
}

/** 카드 유효기간: 숫자만 4자리(MMYY)까지, 2자리 뒤에 자동으로 / 삽입 (MM/YY) */
export function formatExpiry(raw: string): string {
  const d = raw.replace(/\D/g, "").slice(0, 4);
  if (d.length <= 2) return d;
  return `${d.slice(0, 2)}/${d.slice(2)}`;
}
